var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-dialog',{class:_vm.noBottomPadding ? 'modal-no-bottom-padding' : '',attrs:{"top":_vm.top,"visible":_vm.isVisible,"direction":"rtl","width":_vm.width,"append-to-body":_vm.appendToBody},on:{"close":function($event){return _vm.$emit('close')}}},[_c('div',{staticClass:"modalBody"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }